import Konva from "konva";
import {toRaw} from "vue";

export default class AnchorableObject {
  anchors = []
  onchange = null

  constructor(layer, object, group, isReadOnly) {
    this.layer = layer
    this.object = object
    this.group = group
    this.isReadOnly = isReadOnly
  }

  init() {
    const between = (x, a, b) => {
      return a <= x && x <= b
    }
    const almostEqual = (a, b) => {
      return Math.abs(a - b) < 5
    }
    if (!this.isReadOnly) {
      this.object.on('dblclick', () => {
        const { x: mouseX, y: mouseY } = this.object.getRelativePointerPosition()
        const points = structuredClone(toRaw(this.object.getPoints()))
        const insertionCandidates = []
        for (let i = 0; i < points.length / 2; i++) {
          const startX = points[i * 2],
            endX = points[(i * 2 + 2) % points.length],
            startY = points[i * 2 + 1],
            endY = points[(i * 2 + 3) % points.length];
          if (
            (between(mouseX, startX, endX) || between(mouseX, endX, startX) || (almostEqual(endX, startX) && Math.abs(endX - mouseX) <= 10)) &&
            (between(mouseY, startY, endY) || between(mouseY, endY, startY) || (almostEqual(endY, startY) && Math.abs(endY - mouseY) <= 10))
          ) {
            insertionCandidates.push({ position: i + 1, mouseX, mouseY, startX, endX, startY, endY})
          }
        }
        if (insertionCandidates.length > 0) {
          const c = insertionCandidates[0]
          this.buildAnchor(c.mouseX, c.mouseY, c.position)
          this.calcualtePolyPoints()
          this.emitOnChange()
        }
      })
    }
    this.draw()
  }
  draw() {
    const points = this.object.getPoints()
    for (let i = 0; i < points.length; i += 2) {
      const [x, y] = points.slice(i, i + 2)
      this.buildAnchor(x, y)
    }
  }
  redraw() {
    this.group.find('.anchor').forEach(anchor => {
      anchor.destroy()
    })
    this.anchors = []
    this.draw()
  }
  calcualtePolyPoints() {
    this.object.setPoints(this.anchors.map(anc => [anc.x(), anc.y()]).flat())
  }
  buildAnchor(x, y, position = null) {
    if (this.isReadOnly) {
      return;
    }
    const anchor = new Konva.Circle({
      name: 'anchor',
      x: x,
      y: y,
      radius: 6,
      fill: '#fff',
      strokeWidth: 1,
      draggable: true,
    });
    this.group.add(anchor);
    setTimeout(() => {
      anchor.moveToTop()
    }, 0)

    anchor.on('mouseover', function () {
      document.body.style.cursor = 'pointer';
      this.stroke('#03a9f4')
      this.strokeWidth(2);
    });
    anchor.on('mouseout', function () {
      document.body.style.cursor = 'default';
      this.stroke(null)
      this.strokeWidth(1);
    });
    anchor.on('contextmenu', ({ evt }) => {
      evt.preventDefault()
      if (this.anchors.length === 3) {
        return;
      }
      this.emitOnChange()
      anchor.destroy()
      this.anchors = this.anchors.filter(x => x._id != anchor._id)
      this.calcualtePolyPoints()
    })

    anchor.on('dragmove', () => {
      this.emitOnChange()
      this.calcualtePolyPoints()
    });

    this.anchors.splice(position || this.anchors.length, 0, anchor)
  }
  emitOnChange() {
    if (typeof this.onchange == 'function') {
      this.onchange()
    }
  }

}